import { createEngine } from "@feature-flags/lib";
import { loadFeatureFlagPublication } from "./api.js";
async function loadFeatureFlags(project, context) {
  const publication = await loadFeatureFlagPublication(project, context.env);
  return transformPublication(publication, project, context);
}
function transformPublication(publication, project, context) {
  const { locale } = context;
  const [, country] = locale.split("_");
  const flagContext = {
    country,
    ...context
  };
  const { flags, segments } = publication;
  const engine = createEngine({ flags, segments, uniqueId: project });
  const getValue = (flagName) => {
    const { value = false } = engine.eval({ flagName, context: flagContext }) || {};
    return value;
  };
  const featureFlags = flags.reduce((acc, flag) => {
    if (flag.disabled)
      return acc;
    acc[flag.name] = getValue(flag.name);
    return acc;
  }, {});
  return featureFlags;
}
export {
  loadFeatureFlags
};
//# sourceMappingURL=helper.js.map
